import React from 'react'
import styled from 'styled-components'

export const RightTopContainerStyled = styled.div`
  font-size: 18px;
  color: ${({ theme }) => theme.colors.backgroundColor};
  padding: 25px 10%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & span{
    cursor: pointer;
    font-weight: 600;
    ${props => props.theme.rtl ? '' : 'margin-top: -5px;'};
    &:hover{
      color: #ffc2a5;
    }
  }

  // @media (max-width: 990px) {
  //   padding: 5px 7%;
  //   span{
  //     &:hover{
  //       color: white;
  //     }
  //   }
  // }
`

export const RightTopActions = styled.div`
  display: flex;
  align-items: center;
`

export const AboutUsButton = styled.button`
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.primaryButtCol};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.hoverButtCol};
  }
`

export const SearchIconWrapper = styled.div`
  cursor: pointer;  
  ${props => props.theme.rtl ? 'margin-left: 10px' : 'margin-right: 10px'};
  ${() => 'font-size: 14px; width: 40px;height: 40px;background-color: #fff;color: #000;display: flex;justify-content: center;align-items: center;border-radius: 50%;}'};
  & > svg {
    width: 14px;
  };`
  
export const RightTopContainer = (props) => {
  return (
    <RightTopContainerStyled>
      {props.children}
    </RightTopContainerStyled>
  )
}
